'use strict';

var autenticacaoMdl = angular.module('autenticacaoMdl');
autenticacaoMdl.factory('AutenticacaoItp', autenticacaoItp);
autenticacaoItp.$inject = [
    '$cookies',
    'ConfigApp',
    '$injector',
    '$q'];

function autenticacaoItp(
    $cookies,
    ConfigApp,
    $injector,
    $q) {
    return {
        request: function (config) {
            config.headers = config.headers || {};
            var token = $cookies.get('api_token');

            if (!(config.url.indexOf(ConfigApp.UrlApi + '/token') === 0) && token) {
                config.headers.Authorization = 'Bearer ' + $cookies.get('api_token');
            }

            return config;
        },

        responseError: function (rejection) {

            if (rejection.status == 401) {
                $cookies.remove('api_token');
                window.location = ConfigApp.UrlLogin;
            }

            if (rejection.status == 500) {
                toastr.error('Houve um erro interno, por gentileza informe ao setor responsável.', 'Erro 500');
            }

            return $q.reject(rejection);
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/autenticacao/autenticacao-interceptor.js